import { Icon } from 'assets/index'
import { Loading } from 'components/index'
import { Content, Button, FeedbackContainer } from './style'
import confirm from './confirm.png'
import failed from './failed.png'

export const selectOptions: any = {
  accountList: [
    { label: 'Captação aberta', value: [] },
    { label: 'Captação fechada', value: [] },
  ],
  type: [
    { label: 'Cotas imobiliárias', value: 'SPE' },
    { label: 'Empreendimento', value: 'SPC' },
    { label: 'Token', value: 'TOKEN' },
  ],
  guaranteeList: [
    { label: 'SPE', value: 'SPE' },
    { label: 'SCP', value: 'SCP' },
    { label: 'Aval dos sócios', value: 'Aval dos sócios' },
    { label: 'Ativos', value: 'Ativos' },
    { label: 'Não possui', value: 'Não possui' },
  ],
  icoDays: [
    { label: '7 dias', value: 7 },
    { label: '15 dias', value: 15 },
    { label: '30 dias', value: 30 },
    { label: '60 dias', value: 60 },
    { label: '90 dias', value: 90 },
    { label: 'Full', value: 0 },
  ],
  icoDaysPersonal: [
    { label: '7 dias', value: 7 },
    { label: '15 dias', value: 15 },
    { label: '30 dias', value: 30 },
    { label: '60 dias', value: 60 },
    { label: '90 dias', value: 90 },
  ],
  icoPeriod: [
    { label: '7 dias', value: 7 },
    { label: '15 dias', value: 15 },
    { label: '30 dias', value: 30 },
    { label: '60 dias', value: 60 },
    { label: '90 dias', value: 90 },
    { label: 'Full', value: 0 },
  ],
  recurrencyType: [
    { label: 'Diária', value: 'DAILY' },
    { label: 'Mensal', value: 'MONTHLY' },
    { label: 'Trimestral', value: 'QUARTERLY' },
    { label: 'Anual', value: 'ANNUALLY' },
    { label: 'No vencimento', value: 'DEFAULT' },
  ],
  principalLiquidityType: [
    { label: 'Diária', value: 'DAILY' },
    { label: 'Anual', value: 'ANNUALLY' },
    { label: 'No vencimento', value: 'DEFAULT' },
  ],
  paymentType: [
    { label: 'Pré fixado', value: 'PRE' },
    // { label: 'Pós fixado', value: 'POS' },
    // { label: 'Híbrido', value: 'HYBRID' },
  ],
  indiceId: [
    { label: 'IPCA', value: 'IPCA' },
    { label: 'IGP-M', value: 'IGP-M' },
    { label: 'CDI', value: 'CDI' },
  ],
  IRType: [
    { label: 'Descontado na fonte', value: 'Descontado na fonte' },
    { label: 'Não descontado na fonte', value: 'Não descontado na fonte' },
    { label: 'Isento', value: 'Isento' },
  ],
  cotizationIn: [
    { label: 'No dia', value: 0 },
    { label: '1 dia', value: 1 },
    { label: '5 dias', value: 5 },
    { label: '10 dias', value: 10 },
    { label: '15 dias', value: 15 },
    { label: '20 dias', value: 20 },
    { label: '30 dias', value: 30 },
    { label: '60 dias', value: 60 },
    { label: '90 dias', value: 90 },
  ],
  cotizationOut: [
    { label: 'Até 30 dias', value: 30 },
    { label: 'Até 60 dias', value: 60 },
    { label: 'Até 90 dias', value: 90 },
  ],
  isCotizationProfitable: [
    { label: 'Sim', value: 1 },
    { label: 'Não', value: 0 },
  ],
}

export const handleCaptation = (captation: any) => {
  let newOb: any = captation
  const Arr = Object.keys(selectOptions)
  Arr.forEach((item: any) => {
    newOb = {
      ...newOb,
      [item]: selectOptions[item].find(
        (la: any) => la.value === captation[item]
      ),
    }
  })
  console.log(newOb)
}

export const ConfirmModal = (props: any) => {
  const { setConfirmModal, handleSubmit, text } = props
  return (
    <Content>
      <div className="row">
        <p className="big-red-title">Migrar Contrato</p>
      </div>
      <p className="black-title">Tem certeza que quer realizar esta ação?</p>
      <p className="black-content">{text}</p>
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <Button onClick={() => setConfirmModal(false)}>
          <img src={Icon('x.svg')} alt="close modal" className="icon" />
          <p>Cancelar</p>
        </Button>
        <div style={{ marginLeft: 40 }}>
          <Button yellow onClick={() => handleSubmit()}>
            <img src={Icon('check.svg')} alt="conf modal" className="icon" />
            <p>Confirmar</p>
          </Button>
        </div>
      </div>
    </Content>
  )
}

export const ActionFeedback = (props: any) => {
  const { title, error, closeModal } = props
  return (
    <FeedbackContainer error={error}>
      <img
        onClick={() => closeModal()}
        src={Icon('x.svg')}
        alt="close modal"
        className="close-modal"
      />
      <img
        src={error ? failed : confirm}
        alt="check-icon"
        className="confirm-img"
      />
      <h1 className="title-res">{error ? 'Falha na Migração' : title}</h1>
      <span className="error-msg">{error}</span>
    </FeedbackContainer>
  )
}

export const ConfirmLoading = () => {
  return (
    <FeedbackContainer>
      <Loading modal />
    </FeedbackContainer>
  )
}
